<template>
  <div>
    <b-row align-h="between" class="mb-3">
      <b-col cols="6">
        <b-button-group size="md">
          <b-button class="mr-2" variant="outline-success" @click="formLoad('add')" v-if="allow('A')">
            <b-icon-plus></b-icon-plus>
            {{$l('btn_create_project') || '新增'}}
          </b-button>
        </b-button-group>
      </b-col>
      <b-col cols="6">
        <b-form>
          <b-input-group>
            <b-form-input v-model="form.prjTitle" @keyup.enter="query" type="search" placeholder="Search here..."/>
            <b-input-group-append>
              <b-button-group>
                <b-button @click="query" variant="primary" class="my-2 my-sm-0">
                  <i class="fa fa-search"></i>
                </b-button>
                <b-dropdown right variant="light" ref="dropdown">
                  <b-dd-form :inline="true" style="width: 600px;">
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group :label="$l('label_search_status')||'状态'" >
                          <b-form-checkbox-group style="width:100%;" id="checkbox-group-2" v-model="form.prjStatusList">
                            <b-form-checkbox value="S">{{$l('label_search_draft') || '草稿'}}</b-form-checkbox>
                            <b-form-checkbox value="P">{{$l('label_search_haveInHand') || '进行中'}}</b-form-checkbox>
                            <b-form-checkbox value="Y">{{$l('label_search_completed') || '已完成'}}</b-form-checkbox>
                            <b-form-checkbox value="D">{{$l('label_search_Postponed') || '已延期'}}</b-form-checkbox>
                            <b-form-checkbox value="C">{{$l('label_search_Terminated') || '已终止'}}</b-form-checkbox>
                            <b-form-checkbox value="F">{{$l('label_search_Deleted') || '已删除'}}</b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group :label="$l('search_label_sample_type')||'打样类型'" >
                          <b-form-checkbox-group style="width:100%;" id="checkbox-group-2" v-model="form.sampleTypeList">
                            <b-form-checkbox value="S">{{$l('label_search_sProofing') || '样品打样'}}</b-form-checkbox>
                            <b-form-checkbox value="M">{{$l('label_search_fProofing') || '面料打样'}}</b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group :label="$l('label_search_category')||'分类'">
                          <bv-select v-model="form.prjCategoryCode" size="md" url="/digitalCenter/common/dict/customer"></bv-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group :label="$l('label_search_category')||'客户'">
                          <bv-select v-model="form.custCode" size="md" url="/digitalCenter/common/dict/customer"></bv-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group :label="$l('search_label_prj_no')||'项目编号'">
                          <b-form-input style="width:100%;" type="search" v-model="form.prjNo" :placeholder="$l('search_label_prj_no')||'推荐单号'"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col style="text-align:center;">
                        <b-button block variant="primary" @click="query">Search</b-button>
                        <b-button block variant="outline-primary" @click="onReset">Reset</b-button>
                      </b-col>
                    </b-form-row>
                  </b-dd-form>
                </b-dropdown>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <Add ref="add"/>
  </div>
</template>

<script>
export default {
  components: {
      'Add': () => import('@/views/digital/projectManager/info/components/add')
  },
  data () {
    return {
      form: {
        prjNo: '',
        prjTitle: '',
        prjCategoryCode: '',
        custCode: '',
        prjStatusList: [],
        sampleTypeList: []
      }
    }
  },
  methods: {
    formLoad(){
      this.$refs.add.load()
    },
    onReset(){
        this.form = {
            prjNo: '',
            prjTitle: '',
            prjCategoryCode: '',
            custCode: '',
            prjStatusList: [],
            sampleTypeList: []
        }
        this.query()
    },
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.$refs.form.resetFields()
      this.query()
    }
  },
  created () {
    this.query()
  }
}
</script>
